import React from 'react'


export const Icons = () => {
    return (
    
    <div className="icons">
        
        <img className="heart icon" src="/icons/heart.svg" alt="Heart-icon" />
        <img className="play icon" src="/icons/play.svg" alt="Play-icon" />
        <img className="dots icon" src="/icons/dots.svg" alt="Dots-icon" />

    </div>

    )
}